import { render, staticRenderFns } from "./DirectSaleStore.vue?vue&type=template&id=5dbcc70c&scoped=true&"
import script from "./DirectSaleStore.vue?vue&type=script&lang=js&"
export * from "./DirectSaleStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbcc70c",
  null
  
)

export default component.exports